import {buildUrl} from '~/lib/net';
import {setDefaultPaginate} from '~/apps/pos/apis/helpers';
import {defaultTablePageSize} from '~/common/components/consts';
import {ProductListParams} from './params';
import {saleGetListParamsURL} from '~/apps/pos/models';
import {format} from "date-fns";

/**
 *  Product endpoints
 */
export class ProductEndpoints {
  static getProductList = (productListParams: ProductListParams) => {
    return buildUrl(`/api/v2/products/`, setDefaultPaginate(productListParams));
  };

  static getOrgProducts = (orgId, offset = 0, limit = defaultTablePageSize) => {
    return ProductEndpoints.getProductList({
      orgId,
      offset,
      limit,
    });
  };

  static getLocationProducts = (locationId: string, offset = 0, limit = defaultTablePageSize) => {
    return ProductEndpoints.getProductList({
      locationId,
      offset,
      limit,
    });
  };
  static getProductById = (productId: string) => `/api/v2/products/${productId}`;
  static createProduct = () => `/api/v2/products/`;
  static updateProduct = (productId: string) => `/api/v2/products/${productId}`;
}

/**
 *  Additional fields endpoints
 */

export class AdditionalFieldsEndpoints {
  static getAdditionalFieldsByLocationId = (locationId: string) => `/api/v2/locations/${locationId}/additional_fields/`;

  static getAdditionalFieldsByOrgId = (orgId: string) => `/api/v2/organizations/${orgId}/additional_fields/`;

  static addAdditionalField = () => `/api/v2/locations/additional_fields/`;

  static updateAdditionalField = (fieldId: string) => `/api/v2/locations/additional_fields/${fieldId}/`;

  static deleteAdditionalField = (fieldId: string) => `/api/v2/locations/additional_fields/${fieldId}/`;
}

/**
 *  Sale endpoints
 */

export class SaleEndpoints {
  static getSaleList = (saleListParams: saleGetListParamsURL) => {
    const {startDt, endDt, ...rest} = saleListParams
    const params: any = {...rest};

    if (startDt) {
      params.dateStart = format(startDt, 'YYYY-MM-DD');
    }

    if (startDt && endDt) {
      params.dateEnd = format(endDt, "YYYY-MM-DD");
    }

    return buildUrl(`/api/v2/sales/`, setDefaultPaginate(params));
  };
  static getSaleById = (saleId) => `/api/v2/sales/${saleId}`;

  static getSalesTotals = (salesTotalsParams: saleGetListParamsURL) => {
    const params: any = {};

    if (salesTotalsParams?.locationId) {
      params.locationId = salesTotalsParams.locationId;
    }

    if (salesTotalsParams?.departmentId) {
      params.departmentId = salesTotalsParams.departmentId;
    }

    if (salesTotalsParams?.q) {
      params.q = salesTotalsParams.q;
    }

    if (salesTotalsParams?.status) {
      params.status = salesTotalsParams.status;
    }

    if (salesTotalsParams?.startDt) {
      params.dateStart = format(salesTotalsParams.startDt, 'YYYY-MM-DD');
    }

    if (salesTotalsParams?.endDt) {
      params.dateEnd = format(salesTotalsParams.endDt, 'YYYY-MM-DD');
    }

    return buildUrl(`/api/v2/sales-totals`, setDefaultPaginate(params));
  }

  // Model POST body in /src/apps/pos/models/index.ts -> salePostParamsBody
  static createSale = () => `/api/v2/sales/`;
  static updateSale = (saleId) => `/api/v2/sales/${saleId}`;
  static deleteSale = (saleId) => `/api/v2/sales/${saleId}`;
  static paySaleByCode = (saleId) => `/api/v2/sales/${saleId}/pay/code/`;
  static paySaleByCheckout = (saleId) => `/api/v2/sales/${saleId}/pay/checkout/`;
  static paySaleByOther = (saleId) => `/api/v2/sales/${saleId}/pay/other/`;

  static exportSaleCSV = (dateStart, dateEnd) => {
    return buildUrl(`/api/v2/sales/csv/`, {
      dateStart: format(dateStart, 'YYYY-MM-DD'),
      dateEnd: format(dateEnd, 'YYYY-MM-DD'),
    });
  }
  static exportDetailSalesCSV = (dateStart, dateEnd) => {
    return buildUrl(`/api/v2/sales/csv/with-line-items/`, {
      dateStart: format(dateStart, 'YYYY-MM-DD'),
      dateEnd: format(dateEnd, 'YYYY-MM-DD'),
    });
  }
}

/**
 *  Sale message endpoints
 */

export class SaleMessageEndpoints {
  static saleSendEmail = (saleId) => `/api/v2/sales/${saleId}/receipt/send/email/`;

  static saleSendSMS = (saleId) => `/api/v2/sales/${saleId}/receipt/send/sms/`;

  static salePrint = (saleId) => `/api/v2/sales/${saleId}/receipt/print`;

  static checkoutSendText = (saleId) => `/api/v2/sales/${saleId}/checkout/send-text`;

  static checkoutSendEmail = (saleId) => `/api/v2/sales/${saleId}/checkout/send-email`;
}
